import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormControl,
  Validators,
  FormBuilder,
  FormGroup,
  FormArray,
} from '@angular/forms';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';
import * as EmailValidator from 'email-validator';
import { ToastrService } from 'ngx-toastr';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss'],
})
export class CreatePasswordComponent {
  disabled: boolean = true;
  page: number = 3;
  public passwordResetForm!: FormGroup;
  formSubmitted = false;
  passwordResetDone: Object = {};
  sharedData: String = '';
  baseUrl = environment.BASE_URL;
  companyEmail!: any;
  hide = true;
  cHide = true;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private commonServies: CommonService,
    private toastr: ToastrService,
    private gtmService: GoogleTagManagerService,
  ) {}

  ngOnInit() {
    this.companyEmail = localStorage.getItem('customeremail');
    this.passwordResetForm = this.formBuilder.group({
      email: [this.companyEmail || ''],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          this.patternValidator(/\d/, { hasNumber: true }),
          this.patternValidator(/[A-Z]/, { hasUppercase: true }),
          this.patternValidator(/[a-z]/, { hasLowercase: true }),
          this.patternValidator(/[!@#$%^&*(),.?":{}|<>]/, { hasSpecialCharacter: true }),
        ],
      ],
      confirmPassword: ['', Validators.required],
    });

    this.f;

    this.commonServies.sharedData$.subscribe(
      (sharedData: any) => (this.sharedData = sharedData),
    );
  }

  hasError(errorName: string) {
    const control: any = this.passwordResetForm.controls['password'];
    if (control?.touched && control?.errors && errorName != 'minlength') {
      return control?.errors[errorName];
    } else if (control?.touched && control?.errors && errorName == 'minlength') {
      return (
        control?.errors['minlength']?.actualLength <
        control?.errors['minlength']?.requiredLength
      );
    }
  }

  patternValidator(regexp: RegExp, validationOptions: any) {
    return (control: FormControl) => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }

      const valid = regexp.test(control.value);

      // if the control doesn't match the pattern
      return valid ? null : validationOptions;
    };
  }

  get f() {
    return this.passwordResetForm.controls;
  }

  submit() {
    if (this.passwordResetForm.invalid) {
      return;
    }
    this.formSubmitted = true;
    let body = {
      userName: this.companyEmail,
      email: this.companyEmail,
      passWord: this.commonServies.encryptData(this.passwordResetForm.value.password),
    };
    const apiUrl = `${this.baseUrl}auth-service/resetPassword`;
    this.commonServies.postDatawithoutHeaders(apiUrl, body).subscribe((data: any) => {
      this.passwordResetDone = data;
      this.pushEvents();
      this.toastr.success('Your account has been successfully created.');
      this.router.navigateByUrl('/');
    });
    this.page = 4;
  }

  pushEvents() {
    const gtmTag = {
      event: 'password-creation',
      event_category: 'User Input',
      password_creation: 'completed',
    };
    this.gtmService.pushTag(gtmTag);
  }

  togglePasswordVisibility() {
    this.hide = !this.hide;
  }
  get validateEmail() {
    return EmailValidator.validate(this.passwordResetForm.value.email);
  }
  toggleConfirmPasswordVisibility() {
    this.cHide = !this.cHide;
  }
}
